/*
Copyright (c) 2024, HP Development Company, L.P. All rights reserved.
This software contains confidential and proprietary information of HP.
The user of this software agrees not to disclose, disseminate or copy
such Confidential Information and shall use the software only in accordance
with the terms of the license agreement the user entered into with HP.
*/
import { withAnalytics } from '@veneer/analytics';
import React, { memo } from 'react';
import './styles.scss';
import { LinkProps } from './types';
import { generateID } from '../../base/helper';

const TLink = ({
  onClick,
  url,
  label,
  underline,
  size = 'xs',
  tabIndex = 0,
  id = generateID('clientos-ui-toolkit-link'),
  target = '_self'
}: LinkProps) => {
  const linkClass = `clientos-ui-toolkit-link label${size === 'xs' ? '' : '-large'} ${underline ? 'has-underline' : ''}`;
  const handleKeyPress = (e: React.KeyboardEvent) => {
    if (e.key.toLowerCase() === 'enter' || e.key.toLowerCase() === ' ') {
      onClick?.();
    }
  };

  return (
    <a
      {...(url ? { href: url } : {})}
      {...(onClick ? { onClick: onClick } : {})}
      className={linkClass}
      tabIndex={tabIndex}
      id={id}
      target={target}
      onKeyPress={handleKeyPress}
    >
      {label}
    </a>
  );
};

export const LinkAnalytics = withAnalytics(TLink);
export default memo(TLink);
